import React from "react";
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Link,
  useTheme,
  useMediaQuery,
  Typography
} from "@material-ui/core";

import { SMGBacking as SMGBackingIcon, Facebook, LinkedIn, Instagram } from "../Icons";
import LinkEcco, { WrappedLinkRouter } from "../Link";
import { useStyles } from "../../hooks";
import styles from "./styles";
import { PUBLICURL, ASSETS_S3 } from "../../main_config";
/* import Facebook from './images/facebook.png'; */
/* import Instagram from './images/instagram.png';
import Linkedin from './images/linkedin.png'; */

const Footer = ({ showThirdColum = true }) => {
  const classes = useStyles(styles);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  return (
    <Box component="footer" className={showThirdColum ? classes.root : classes.rootAsociate}>
      {!matches &&
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: "center"
          }}
          className={classes.redesMobile}
        >
          <Grid xs={3} className={classes.textMobile}>¡Seguinos!</Grid>
          <Grid xs={6} /* className={classes.crossIcon} */ >
            <LinkEcco
              external={true}
              url="https://www.facebook.com/eccoemergencias"
              href="https://www.facebook.com/eccoemergencias"
              target="_blank"
              style={{ cursor: 'pointer', color: "#fff" }}
            >
              <Facebook style={{ marginRight: 20 }} />
            </LinkEcco>
            <LinkEcco
              external={true}
              url="https://www.instagram.com/eccoemergencias"
              href="https://www.instagram.com/eccoemergencias"
              target="_blank"
              style={{ cursor: 'pointer', color: "#fff" }}
            >
              <Instagram style={{ marginRight: 20 }} />
            </LinkEcco>
            <LinkEcco
              external={true}
              url="https://www.linkedin.com/company/eccoemergencias"
              href="https://www.linkedin.com/company/eccoemergencias"
              target="_blank"
              style={{ cursor: 'pointer', color: "#fff" }}
            >
              <LinkedIn />
            </LinkEcco>
          </Grid></Grid>}
      <Grid
        container
        spacing={0}
        justify="space-between"
        className={classes.wrapper}
        style={{marginTop: !showThirdColum ? matches ? 8 : 0 : 0 }}
      >
        <Grid item xs={12} sm={9} md={9}>
          <Grid container spacing={0} className={classes.wrapper}>
            <Grid item xs={showThirdColum ? 5 : 6} sm={3} md={3} className={classes.info}>
              <List dense disablePadding>
                <ListItem disableGutters classes={{ dense: classes.itemDense }} style= {{marginTop: !showThirdColum ? !matches ? 13 : 0 : 0}}>
                  <ListItemText
                    disableTypography
                    classes={{ dense: classes.textDense }}
                  >
                   {/*  <Box component="span" className={showThirdColum ? classes.text : classes.textM} style={{ display: showThirdColum ? "block" : "none" }}>
                      Superintendencia de Servicios de Salud
                    </Box> */}
                    <Box component="span" className={showThirdColum ? classes.text : classes.textM} style={{ /* display: showThirdColum ? "auto" : "none", */ marginTop: !showThirdColum ? "8px" : 0, marginBottom: !showThirdColum ? "1px" : 0 }}>
                      Superintendencia de Servicios de Salud
                    </Box>
                  </ListItemText>
                </ListItem>
                <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                  <ListItemText
                    disableTypography
                    classes={{ dense: classes.textDense }}
                  >
                    <Box component="span" className={showThirdColum ? classes.text : classes.textM}>
                      Organo Control 0800-222-SALUD (72583)
                    </Box>
                  </ListItemText>
                </ListItem>
                <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                  <ListItemText
                    disableTypography
                    classes={{ dense: classes.textDense }}
                  >
                    <Link
                      href="http://www.sssalud.gob.ar"
                      target="_blank"
                      className={showThirdColum ? classes.text : classes.textM}
                      underline="none"
                      color="inherit"
                    >
                      www.sssalud.gob.ar
                    </Link>
                    <Box component="span" className={showThirdColum ? classes.text : classes.textM}>
                      {" | RNEMP Nº 1347"}
                    </Box>
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>

            {!matches ? (
              <Grid item xs={6} style={{ display: showThirdColum ? "block" : "none" }}>
                <Grid container spacing={0} className={classes.wrappedlogoSmg}>

                  <Grid item xs={12}>
                    <List dense disablePadding>
                      <ListItem disableGutters classes={{ dense: classes.LinkDense }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${PUBLICURL}/st/linea-denuncias`}
                            className={classes.textLink}
                            underline="none"
                            color="inherit"

                          >
                            Línea de denuncias
                          </Link>
                        </ListItemText>
                      </ListItem>
                      <ListItem disableGutters classes={{ dense: classes.LinkDense }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${PUBLICURL}/st/solicitud-baja`}
                            className={classes.textLink}
                            underline="none"
                            color="inherit"
                          >
                            Solicitá la baja
                          </Link>
                        </ListItemText>
                      </ListItem>
                      <ListItem disableGutters classes={{ dense: classes.LinkDense }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${PUBLICURL}/st/solicitud-arrepentimiento`}
                            className={classes.textLink}
                            underline="none"
                            color="inherit"
                          >
                            Solicitá el arrepentimiento
                          </Link>
                        </ListItemText>
                      </ListItem>
                      <ListItem disableGutters classes={{ dense: classes.LinkDense }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${ASSETS_S3}/pdf/Contrato_de_Adhesión_Ley_N_24240_de_Defensa_del_Consumidor.pdf`}
                            target="_blank"
                            className={classes.textLink}
                            underline="none"
                            color="inherit"
                          >
                            Contrato de Adhesión
                          </Link>
                        </ListItemText>
                      </ListItem>
                      <ListItem disableGutters classes={{ dense: classes.LinkDense }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${ASSETS_S3}/pdf/y385etjo.pdf`}
                            target="_blank"
                            className={classes.textLink}
                            underline="none"
                            color="inherit"
                          >
                            Código de Gobierno Corporativo
                          </Link>
                        </ListItemText>
                      </ListItem>
                      <ListItem disableGutters classes={{ dense: classes.LinkDense }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${ASSETS_S3}/pdf/ut3424om.pdf`}
                            target="_blank"
                            className={classes.textLink}
                            underline="none"
                            color="inherit"
                          >
                            Código de Ética
                          </Link>
                        </ListItemText>
                      </ListItem>
                    </List>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid item xs={7} sm={6} md={6}>
                <Grid container spacing={0} className={classes.wrappedlogoSmg} style={{marginTop: !showThirdColum ? '-20px' : 0}} >

                  <Grid item xs={6} className={classes.borderLeft} style={{ display: showThirdColum ? "block" : "none" }}>
                    <SMGBackingIcon className={classes.smgImage} />
                  </Grid>
                  <Grid item xs={6} className={classes.borderLeft} style={{ display: !showThirdColum ? "block" : "none", marginTop: "15px" }}>
                    <SMGBackingIcon className={classes.smgImage} />
                  </Grid>
                  {showThirdColum ?
                    <Grid item xs={6}>
                      <List dense>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${PUBLICURL}/st/linea-denuncias`}
                              className={showThirdColum ? classes.text : classes.textM}
                              underline="none"
                              color="inherit"
                            >
                              Línea de denuncias
                            </Link>
                          </ListItemText>
                        </ListItem>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${PUBLICURL}/st/solicitud-baja`}
                              className={showThirdColum ? classes.text : classes.textM}
                              underline="none"
                              color="inherit"
                            >
                              Solicitá la baja
                            </Link>
                          </ListItemText>
                        </ListItem>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${PUBLICURL}/st/solicitud-arrepentimiento`}
                              className={showThirdColum ? classes.text : classes.textM}
                              underline="none"
                              color="inherit"
                            >
                              Solicitá el arrepentimiento
                            </Link>
                          </ListItemText>
                        </ListItem>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${ASSETS_S3}/pdf/Contrato_de_Adhesión_Ley_N_24240_de_Defensa_del_Consumidor.pdf`}
                              target="_blank"
                              className={showThirdColum ? classes.text : classes.textM}
                              underline="none"
                              color="inherit"
                            >
                              Contrato de Adhesión
                            </Link>
                          </ListItemText>
                        </ListItem>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${ASSETS_S3}/pdf/y385etjo.pdf`}
                              target="_blank"
                              className={showThirdColum ? classes.text : classes.textM}
                              underline="none"
                              color="inherit"
                            >
                              Código de Gobierno Corporativo
                            </Link>
                          </ListItemText>
                        </ListItem>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${ASSETS_S3}/pdf/ut3424om.pdf`}
                              target="_blank"
                              className={showThirdColum ? classes.text : classes.textM}
                              underline="none"
                              color="inherit"
                            >
                              Código de Ética
                            </Link>
                          </ListItemText>
                        </ListItem>
                      </List>
                    </Grid>
                    :
                    <Grid item xs={6} style={{ marginTop: showThirdColum ? 20 : 15 }}>
                      {showThirdColum ?
                        <Box className={classes.crossIcon} >
                          <Typography variant="h6" className={classes.textRedes}>
                            ¡Seguinos!
                          </Typography>
                          <LinkEcco
                            external={true}
                            url="https://www.facebook.com/eccoemergencias"
                            href="https://www.facebook.com/eccoemergencias"
                            target="_blank"
                            style={{ cursor: 'pointer', color: "#fff"}}
                          >
                            <Facebook style={{ marginRight: 5 }} />
                          </LinkEcco>
                          <LinkEcco
                            external={true}
                            url="https://www.instagram.com/eccoemergencias"
                            href="https://www.instagram.com/eccoemergencias"
                            target="_blank"
                            style={{ cursor: 'pointer', color: "#fff" }}
                          >
                            <Instagram style={{ marginRight: 5 }} />
                          </LinkEcco>
                          <LinkEcco
                            external={true}
                            url="https://www.linkedin.com/company/eccoemergencias"
                            href="https://www.linkedin.com/company/eccoemergencias"
                            target="_blank"
                            style={{ cursor: 'pointer', color: "#fff" }}
                          >
                            <LinkedIn />
                          </LinkEcco>
                        </Box>
                        :
                        <Box className={classes.crossIcon} style={{ marginLeft: "-90px" }}>
                          <Typography variant="h6" className={classes.textRedes}>
                            ¡Seguinos!
                          </Typography>
                          <LinkEcco
                            external={true}
                            url="https://www.facebook.com/eccoemergencias"
                            href="https://www.facebook.com/eccoemergencias"
                            target="_blank"
                            style={{ cursor: 'pointer', color: "#fff" }}
                          >
                            <Facebook style={{ marginRight: 5, marginLeft: !showThirdColum ? 25 : 0  }} />
                          </LinkEcco>
                          <LinkEcco
                            external={true}
                            url="https://www.instagram.com/eccoemergencias"
                            href="https://www.instagram.com/eccoemergencias"
                            target="_blank"
                            style={{ cursor: 'pointer', color: "#fff" }}
                          >
                            <Instagram style={{ marginRight: 5 }} />
                          </LinkEcco>
                          <LinkEcco
                            external={true}
                            url="https://www.linkedin.com/company/eccoemergencias"
                            href="https://www.linkedin.com/company/eccoemergencias"
                            target="_blank"
                            style={{ cursor: 'pointer', color: "#fff" }}
                          >
                            <LinkedIn />
                          </LinkEcco>
                        </Box>
                      }
                    </Grid>
                  }
                </Grid>
              </Grid>
            )}
            {matches &&
              <Grid item xs="auto" className={classes.borderLeftRedes} style={{ display: showThirdColum ? "block" : "none" }}>
                <Box className={classes.crossIcon} >
                  <Typography variant="h6" className={classes.textRedes}>
                    ¡Seguinos!
                  </Typography>
                  <LinkEcco
                    external={true}
                    url="https://www.facebook.com/eccoemergencias"
                    href="https://www.facebook.com/eccoemergencias"
                    target="_blank"
                    style={{ cursor: 'pointer', color: "#fff" }}
                  >
                    <Facebook style={{ marginRight: 5 }} />
                  </LinkEcco>
                  <LinkEcco
                    external={true}
                    url="https://www.instagram.com/eccoemergencias"
                    href="https://www.instagram.com/eccoemergencias"
                    target="_blank"
                    style={{ cursor: 'pointer', color: "#fff" }}
                  >
                    <Instagram style={{ marginRight: 5 }} />
                  </LinkEcco>
                  <LinkEcco
                    external={true}
                    url="https://www.linkedin.com/company/eccoemergencias"
                    href="https://www.linkedin.com/company/eccoemergencias"
                    target="_blank"
                    style={{ cursor: 'pointer', color: "#fff" }}
                  >
                    <LinkedIn />
                  </LinkEcco>
                </Box>
              </Grid>}
          </Grid>

        </Grid>
        {!matches ? (
          <Grid container>
            <Grid item xs={6} >
              <Box className={classes.wrappedLogoLegal}>
                <img
                  src={`${PUBLICURL}/assets/images/legal-group/logo_verisign.png`}
                  alt="Verisign"
                />
                <img
                  src={`${PUBLICURL}/assets/images/legal-group/logo_ministerio_justicia.png`}
                  alt="Ministerio de Justicia"
                />
              </Box>
            </Grid>
            {showThirdColum ?
              <Grid item xs={6}>
                <Box>
                  <SMGBackingIcon className={classes.smgImageMobile} />
                </Box>
              </Grid>
              :
              <Grid item xs={6}>
                <Box>
                  <SMGBackingIcon className={classes.smgImageMobileLanding} />
                </Box>
              </Grid>}
          </Grid>) : (
          <Grid item xs="auto" sm={3} md={3}>
           {/*  <Box className={classes.wrappedLogoLegal} style={{ display: showThirdColum ? "auto" : "none" }}>
              <img
                src={`${PUBLICURL}/assets/images/legal-group/logo_verisign.png`}
                alt="Verisign"
                className={classes.img1}
              />
              <img
                src={`${PUBLICURL}/assets/images/legal-group/logo_ministerio_justicia.png`}
                alt="Ministerio de Justicia"
                className={classes.img2}
              />
            </Box> */}
            <Box className={classes.wrappedLogoLegal} /* style={{ display: !showThirdColum ? "auto" : "none" , marginTop: "15px" */>
              <img
                src={`${PUBLICURL}/assets/images/legal-group/logo_verisign.png`}
                alt="Verisign"
                className={classes.img1}
              />
              <img
                src={`${PUBLICURL}/assets/images/legal-group/logo_ministerio_justicia.png`}
                alt="Ministerio de Justicia"
                className={classes.img2}
              />
            </Box>
          </Grid>)}
      </Grid>
    </Box>
  );
};

export default Footer;